import { z } from 'zod';

// Form schema is purpose-built for this dialog rather than reusing the
// shared AdvanceFormSchema, so the inferred type stays exact under
// tsconfig `exactOptionalPropertyTypes`.

// React Hook Form delivers an empty string for unfilled text inputs; map it
// to undefined so optional fields are treated as "not provided" rather than
// "too short". `.preprocess` runs before the inner schema validates.
const optionalCompanyText = z.preprocess(
  (v) => (typeof v === 'string' && v.trim() === '' ? undefined : v),
  z.string().min(1).max(255).optional(),
);

export const ADVANCE_SUBMIT_FIELDS = z.object({
  invoice_number: z.string().min(1, 'Invoice number is required'),
  currency: z.enum(['USD', 'EUR']),
  total_amount: z.coerce.number().positive(),
  vat_amount: z.coerce.number().nonnegative(),
  original_due_date: z.coerce.date(),
  applied_downpayment_amount: z.coerce.number().nonnegative(),
  issuer_company_name: optionalCompanyText,
  company_name: optionalCompanyText,
});

export type AdvanceSubmitValues = z.infer<typeof ADVANCE_SUBMIT_FIELDS>;
